<div
  *ngIf="customStyle$ | async as customStyle"
  class="header-movie-menu-styles"
  [innerHTML]="customStyle | safe: 'html'"
></div>

<footer id="footer-container">
  <!-- There is something wrong with this implementation of custom template not working for some reason on widget -->
  <ng-container *ngTemplateOutlet="customTemplate; context: listOfVariables"></ng-container>
  <ng-container *ngIf="!customTemplate">
    <ng-container *ngIf="channel.commsConsumerSignup">
      <div id="footer-subscribe-form">
        <ush-showtime-streaming-subscribe [type]="'all'"></ush-showtime-streaming-subscribe>
      </div>
    </ng-container>
    <div class="footer-wrapper" [ngClass]="{ 'transparent-background': transparentBackground }">
      <div id="footer" class="p-grid">
        @if (!appOnlyHasMovies) {
          <div class="footer-logo" [class.footer-logos]="mutiplelogos">
            <ng-container *ngIf="!mutiplelogos; else mutiplelogosTemplate">
              <a *ngIf="!logoLinkExternal" [routerLink]="logoLink" class="nav-logo nav-link">
                <img
                  *ngIf="logoUrl?.indexOf('/assets/') !== 0; else assetImg"
                  [src]="logoUrl | img: logoParams"
                  alt="logo"
                  class="footer-icon"
                />
                <ng-template #assetImg>
                  <img [src]="logoUrl" alt="logo" class="footer-icon" />
                </ng-template>
              </a>
              <a *ngIf="logoLinkExternal" [href]="logoLink" class="nav-logo nav-link">
                <img [src]="logoUrl | img: logoParams" alt="logo" class="footer-icon" />
              </a>
            </ng-container>

            <ng-template #mutiplelogosTemplate>
              <span [attr.data-translate]="multiplelogosText">{{ multiplelogosText | translate }}</span>

              <ng-container *ngFor="let logo of mutiplelogos">
                <a
                  class="nav-logo nav-link"
                  *ngIf="!logo?.logoLinkExternal"
                  [routerLink]="logo?.logoLink"
                  [ngClass]="logo?.logoClass"
                >
                  <img
                    class="footer-icon"
                    *ngIf="logo?.logoUrl?.indexOf('/assets/') !== 0; else logoAssetImg"
                    [src]="logo?.logoUrl | img: logo?.logoParams"
                    alt="{{ logo?.logoAlt ? logo?.logoAlt : 'logo ' + logo?.logoClass }}"
                  />
                </a>
                <a
                  class="nav-logo nav-link"
                  *ngIf="logo?.logoLinkExternal"
                  [href]="logo?.logoLink"
                  [ngClass]="logo?.logoClass"
                >
                  <img
                    class="footer-icon"
                    *ngIf="logo?.logoUrl?.indexOf('/assets/') !== 0; else logoAssetImg"
                    [src]="logo?.logoUrl | img: logoParams"
                    alt="{{ logo?.logoAlt ? logo?.logoAlt : 'logo ' + logo?.logoClass }}"
                  />
                </a>

                <ng-template #logoAssetImg>
                  <img
                    class="footer-icon"
                    [src]="logo?.logoUrl"
                    alt="{{ logo?.logoAlt ? logo?.logoAlt : 'logo ' + logo?.logoClass }}"
                  />
                </ng-template>
              </ng-container>
            </ng-template>
          </div>
        }

        <ush-social-links

          [socialNetworks]="socialLinks"
        ></ush-social-links>

        <ng-container *ngIf="links.length > 0">
          <div class="footer-menu-wrap">
            <ul class="footer-menu">
              <li *ngFor="let link of links" (click)="onFooterLinkClicked(link)">
                <a
                  *ngIf="link.isExternal"
                  [attr.data-external]="link?.isExternal || false"
                  [href]="link?.isExternal ? link.link : null"
                  target="_blank"
                  class="nav-link bold"
                  [attr.data-translate]="getTermsMsg(link.name | cammelCase)"
                >
                  {{ getTermsMsg(link.name | cammelCase) | translate: { placeholder: link.name } }}
                  <div class="border"></div>
                </a>
                <a
                  *ngIf="!link.isExternal"
                  [attr.data-external]="link?.isExternal || false"
                  [routerLink]="!link?.isParent && !link?.isPopup && !link?.isExternal ? link.url || link.link : null"
                  [fragment]="link?.fragment"
                  [ngClass]="{ active: link.isActive, hasLink: link?.link, isParent: link?.isParent }"
                  class="nav-link bold"
                  [attr.data-translate]="getTermsMsg(link.name | cammelCase)"
                >
                  {{ getTermsMsg(link.name | cammelCase) | translate: { placeholder: link.name } }}

                  <div class="border"></div>
                </a>
              </li>
              <!-- footer custom link -->
              <ng-container *ngIf="footerCustomLinkTemplate">
                <ng-container
                  [ngTemplateOutlet]="footerCustomLinkTemplate"
                  [ngTemplateOutletContext]="{ $implicit: footerInstance }"
                ></ng-container>
              </ng-container>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngIf="copyrightMsg">
          <div class="copyright">
            {{ copyrightMsg }}
          </div>
        </ng-container>

        <ush-language-selector *ngIf="channelMultipleLanguages"></ush-language-selector>

        <!-- usheru logo -->
        <ush-usheru-logo
          [ngClass]="{
            'only-element':
              appOnlyHasMovies &&
              links.length <= 0 &&
              hasSocialLinks &&
              socialLinks?.length <= 0 &&
              !copyrightMsg &&
              !channelMultipleLanguages
          }"
        ></ush-usheru-logo>

        <!-- end usheru logo -->
      </div>
    </div>
  </ng-container>
</footer>
